module.exports = __webpack_public_path__ + "static/img/icon_close.3790c1b9.svg";